import { useNavigate } from 'react-router-dom';
import Button from '../components/Button';
import { AlertTriangle } from 'lucide-react';

const ContestantRegistration = () => {
  const navigate = useNavigate();

  return (
    <div className="max-w-2xl mx-auto pt-32 pb-16 px-4 text-center">
      <div className="bg-white rounded-xl shadow-md p-10 border">
        <AlertTriangle size={48} className="mx-auto text-amber-500 mb-4" />
        <h1 className="text-3xl font-heading font-bold text-primary-900 mb-4">
          Contestant Entries Have Been Closed!
        </h1>
        <p className="text-lg text-gray-700 mb-3">
          As of Tuesday June 30th at 11 pm, no more entries are being accepted for the rodeo.
        </p>
        <p className="text-xl font-semibold text-primary-800 mb-6">
          See you this weekend, happy 4th of July!
        </p>
        <Button variant="primary" onClick={() => navigate('/')}>
          Back to Home
        </Button>
      </div>
    </div>
  );
};

export default ContestantRegistration;
